import { CarryOutOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import CompleteTask from 'automations/components/Nodes/CompleteTask';
import { type CompleteTaskNodeType } from 'automations/types/nodeSchemas/actionNodes';
import { nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type ActionNodeReturnProps } from './useActionNodeConfig';

export default function useCompleteTask(node: NodeProps<CompleteTaskNodeType>): ActionNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.CompleteTaskNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <CompleteTask node={node} />, [node]);

  return {
    icon: CarryOutOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
